import React, { useContext } from "react";
import type { MenuProps } from "antd";
import { Menu } from "antd";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import DataContext from "../../context/DataContext";
import { getMenuItems } from "./Navigation";

const Navbar = () => {
  const navigate = useNavigate();
  const { onLogout, clientIdSelected, role, handleRouteBasedOnRole } =
    useContext(AuthContext);

  const { projectSelected, handleChangeProjectSelected, projectList } =
    useContext(DataContext);

  const { handleTour } = useContext(DataContext);

  const onClick: MenuProps["onClick"] = ({ key }) => {
    if (key === "logout") {
      onLogout(() => navigate("/login"));
    } else if (key === "help") {
      handleTour(true);
    } else if (key === "client-files") {
      handleRouteBasedOnRole(clientIdSelected);
    } else if (key === "customer-project") {
      const idProject = projectList[0]?._id;
      handleChangeProjectSelected(idProject);
      navigate(`/customer-project/${clientIdSelected}/${idProject}`);
    } else {
      navigate(key);
    }
  };

  return (
    <>
      <Menu
        className="pt-2"
        onClick={onClick}
        defaultSelectedKeys={["1"]}
        mode="vertical"
        items={getMenuItems(clientIdSelected, projectSelected, role)}
      />
    </>
  );
};

export default Navbar;
